import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ProductPage } from './pages/ProductPage';
import { useScreenInit } from './useScreenInit';
import { OrderModal } from './components/OrderModal';
import { AddedToCartModal } from './components/AddedToCartModal';
import { Header } from './components/Header';
function AppRoutes() {
  useScreenInit();
  return <>
      <Header data-id="element-0" data-mp="2rlf5yrr73m2b" />
      <Routes data-id="element-1" data-mp="2rit1x23ijoou">
        <Route path="/" element={<LandingPage data-id="element-3" data-mp="2mmcd05ohp6ap" />} data-id="element-2" data-mp="2mlu8ymvl5ns8" />
        <Route path="/product/:id" element={<ProductPage data-id="element-5" data-mp="2mjpyfm36lqiz" />} data-id="element-4" data-mp="2mn5b6i9dunh8" />
      </Routes>
      <OrderModal data-id="element-6" data-mp="31aysc7e49y1x" />
      <AddedToCartModal data-id="element-7" data-mp="31bibtsjf0ui2" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-8" data-mp="2wjgptewg3peu">
      <AppRoutes data-id="element-9" data-mp="2wiyuqllirh8i" />
    </BrowserRouter>;
}